
import { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    servicio: '',
    fecha: '',
    personas: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d43arrheds0ugd973lpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('¡Mensaje enviado exitosamente! Te contactaremos pronto.');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          servicio: '',
          fecha: '',
          personas: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('Error al enviar el mensaje. Por favor intenta nuevamente.');
      }
    } catch (error) {
      setSubmitStatus('Error al enviar el mensaje. Por favor intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
            Contáctanos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ¿Listo para vivir una aventura inolvidable en el páramo de Ocetá? Contáctanos y diseñemos juntos tu experiencia perfecta de ecoturismo.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Información de contacto */}
          <div>
            <h3 className="text-3xl font-bold text-green-800 mb-8" style={{ fontFamily: 'Pacifico, serif' }}>
              Información de Contacto
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-1">Dirección</h4>
                  <p className="text-gray-600">Calle 5 # 6 14, Mongua, Boyacá, Colombia</p>
                  <p className="text-sm text-green-600 font-medium">Mongua, tierra del sol naciente</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-1">Teléfonos</h4>
                  <p className="text-gray-600">+57 310 254 7961</p>
                  <p className="text-gray-600">+57 311 890 3404</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-1">WhatsApp</h4>
                  <p className="text-gray-600">+57 310 254 7961</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-1">Email</h4>
                  <p className="text-gray-600">ecoffetours@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-1">Instagram</h4>
                  <p className="text-gray-600">@ecoffetours_agenciadeturismo</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-1">Horarios de Atención</h4>
                  <p className="text-gray-600">Lunes a Domingo: 8:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>

            {/* Mapa */}
            <div className="mt-8">
              <h4 className="font-semibold text-green-800 mb-4">Nuestra Ubicación</h4>
              <div className="h-64 rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.5!2d-72.79978042553051!3d5.755702464161156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwNDUnMjAuNSJOIDcywrA0Nyc1OS4yIlc!5e0!3m2!1ses!2sco!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación Ecoffetours Mongua"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Formulario de contacto */}
          <div>
            <h3 className="text-3xl font-bold text-green-800 mb-8" style={{ fontFamily: 'Pacifico, serif' }}>
              Solicita Tu Cotización
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contacto-ecoffetours-email">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="tu@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="+57 300 123 4567"
                  />
                </div>

                <div>
                  <label htmlFor="servicio" className="block text-sm font-semibold text-gray-700 mb-2">
                    Servicio de Interés *
                  </label>
                  <select
                    id="servicio"
                    name="servicio"
                    value={formData.servicio}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Selecciona un servicio</option>
                    <option value="senderismo">Senderismo Ecológico</option>
                    <option value="avistamiento">Avistamiento de Aves</option>
                    <option value="camping">Camping Aventura</option>
                    <option value="fotografia">Tours Fotográficos</option>
                    <option value="personalizado">Tour Personalizado</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="fecha" className="block text-sm font-semibold text-gray-700 mb-2">
                    Fecha Preferida
                  </label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="personas" className="block text-sm font-semibold text-gray-700 mb-2">
                    Número de Personas
                  </label>
                  <select
                    id="personas"
                    name="personas"
                    value={formData.personas}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-5 0 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Selecciona</option>
                    <option value="1">1 persona</option>
                    <option value="2">2 personas</option>
                    <option value="3-5">3-5 personas</option>
                    <option value="6-10">6-10 personas</option>
                    <option value="mas-10">Más de 10 personas</option>
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-700 mb-2">
                  Mensaje Adicional
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none"
                  placeholder="Cuéntanos más detalles sobre tu aventura ideal..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              {submitStatus && (
                <div className={`p-4 rounded-lg ${submitStatus.includes('exitosamente') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                  {submitStatus}
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-green-600 hover:bg-green-7

                ened disabled:bg-gray-400 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line mr-2"></i>
                    Enviar Solicitud
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
